'use strict';

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");


// override date validation
$.validator.addMethod('date', function (value, element) {
    if (this.optional(element)) {
        return true;
    }
    return (0, _moment2.default)(value, ["L LT", "L"]).isValid();
});

function setDateTimePicker(element, format) {
    if (!format) {
        format = getDateTimePickerFormat(element);
    }
    $(element).datetimepicker({ locale: _moment2.default.locale(), showClear: true, showTodayButton: true, useCurrent: false, format: format, widgetPositioning: { horizontal: 'auto', vertical: 'bottom' } });
}

function getDateTimePickerFormat(element) {
    var $t = $(element);
    var format = "L LT";
    if ($t.hasClass("dtp-date")) {
        format = "L";
    } else if ($t.hasClass("dtp-time")) {
        format = "LT";
    }
    return format;
}

module.exports = exports.default = function () {
    $('input[data-provider=datepicker]', this).each(function (i, e) {
        setDateTimePicker(e);
    });
    $(".input-daterange[data-provider=datepicker]", this).each(function (i, e) {
        var $i1 = $("input:first", e);
        var $i2 = $("input:last", e);

        var minDate = $i1.val();
        var maxDate = $i2.val();

        var format = getDateTimePickerFormat(e);
        setDateTimePicker($i1, format);
        setDateTimePicker($i2, format);

        // initial range
        if (minDate != '') {
            $i2.data("DateTimePicker").minDate(minDate);
        }
        if (maxDate != '') {
            $i1.data("DateTimePicker").maxDate(maxDate);
        }

        $i1.on("dp.change", function (e) {
            $i2.data("DateTimePicker").minDate(e.date);
        });
        $i2.on("dp.change", function (e) {
            $i1.data("DateTimePicker").maxDate(e.date);
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/datepicker.js
// module id = 428
// module chunks = 0